import {
  EnvironmentProviders,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { QarepaNavigationHistoryService } from '@qarepa/common';
import { initializeLinkTags } from '@qaroni-merchant-core/utils/scripts/link-tags';
import { initializeMetaTags } from '@qaroni-merchant-core/utils/scripts/meta-tags';
import { initializeMapScript } from '@qaroni-merchant-core/utils/scripts/script-map';

export const provideInitialize = (): EnvironmentProviders[] => {
  return [
    provideAppInitializer(() => {
      const initializerFn = initializeLinkTags();
      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = initializeMetaTags(inject(Meta));
      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = initializeMapScript();
      return initializerFn();
    }),
    provideAppInitializer(() => inject(QarepaNavigationHistoryService).init()),
  ];
};
